import clsx from 'clsx';

export interface IconQuestionMarkProps {
  className?: string;
}
const IconQuestionMark = ({ className }: IconQuestionMarkProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(
      'fill-brand-gray-100 transition-all duration-300 group-hover/button:fill-brand-primary-100 group-focus/button:fill-brand-primary-100 group-active/button:fill-brand-primary-100 motion-reduce:transition-none',
      className,
    )}
  >
    <path d="M8.91667 12.5C8.91667 11.5 9.01736 10.7535 9.21875 10.2604C9.42014 9.76736 9.84028 9.24306 10.4792 8.6875C11.0764 8.17361 11.4792 7.76042 11.6875 7.44792C11.8958 7.13542 12 6.78472 12 6.39583C12 5.86806 11.8125 5.43403 11.4375 5.09375C11.0625 4.75347 10.5833 4.58333 10 4.58333C9.48611 4.58333 9.03472 4.74306 8.64583 5.0625C8.25694 5.38194 7.97917 5.81944 7.8125 6.375L5.8125 5.54167C6.10417 4.625 6.63542 3.88889 7.40625 3.33333C8.17708 2.77778 9.04167 2.5 10 2.5C11.2361 2.5 12.2431 2.85764 13.0208 3.57292C13.7986 4.28819 14.1875 5.20833 14.1875 6.33333C14.1875 6.91667 14.059 7.44792 13.8021 7.92708C13.5451 8.40625 13.0833 8.95833 12.4167 9.58333C11.8472 10.1111 11.4965 10.5312 11.3646 10.8438C11.2326 11.1562 11.1597 11.7083 11.1458 12.5H8.91667ZM10 17C9.58333 17 9.22917 16.8542 8.9375 16.5625C8.64583 16.2708 8.5 15.9167 8.5 15.5C8.5 15.0833 8.64583 14.7292 8.9375 14.4375C9.22917 14.1458 9.58333 14 10 14C10.4167 14 10.7708 14.1458 11.0625 14.4375C11.3542 14.7292 11.5 15.0833 11.5 15.5C11.5 15.9167 11.3542 16.2708 11.0625 16.5625C10.7708 16.8542 10.4167 17 10 17Z" />
  </svg>
);

export default IconQuestionMark;
